export const HOME_PAGE_SIZE = 15;

export function readPage(value) {
  return /^[1-9]\d*$/.test(value || "") && Number.isSafeInteger(Number(value))
    ? Number(value) : 1;
}

// The API currently uses batches of ten. Read its metadata so changes in
// server batch size do not silently skip posts.
export async function loadHomePage(request, wantedPage) {
  const first = await request(1);
  const batchSize = Number(first.per_page);
  const total = Number(first.total);
  if (!Number.isSafeInteger(batchSize) || batchSize < 1 ||
      !Number.isSafeInteger(total) || total < 0 || !Array.isArray(first.data)) {
    throw new Error("Invalid pagination response");
  }
  const lastPage = Math.max(1, Math.ceil(total / HOME_PAGE_SIZE));
  const page = Math.min(readPage(String(wantedPage)), lastPage);
  const start = (page - 1) * HOME_PAGE_SIZE;
  const end = Math.min(start + HOME_PAGE_SIZE, total);
  if (!total) return { page, total, lastPage, items: [] };
  const firstBatch = Math.floor(start / batchSize) + 1;
  const lastBatch = Math.floor((end - 1) / batchSize) + 1;
  const batches = await Promise.all(
    Array.from({ length: lastBatch - firstBatch + 1 }, (_, i) => {
      const number = firstBatch + i;
      return number === 1 ? first : request(number);
    })
  );
  batches.forEach((batch, i) => {
    if (Number(batch.current_page) !== firstBatch + i ||
        Number(batch.per_page) !== batchSize || Number(batch.total) !== total ||
        !Array.isArray(batch.data)) {
      throw new Error("Posts changed while loading. Please try again.");
    }
  });
  const items = [].concat(...batches.map(batch => batch.data))
    .slice(start % batchSize, start % batchSize + end - start);
  if (items.length !== end - start) throw new Error("Incomplete post page");
  const keys = items.map(item => item.slug || item.id);
  if (keys.every(key => key !== undefined) && new Set(keys).size !== keys.length) {
    throw new Error("Duplicate posts returned. Please try again.");
  }
  return { page, total, lastPage, items };
}

export function pageNumbers(page, lastPage) {
  const values = [...new Set([1, page - 1, page, page + 1, lastPage])]
    .filter(value => value >= 1 && value <= lastPage).sort((a, b) => a - b);
  const result = [];
  values.forEach((value, i) => {
    if (i && value - values[i - 1] > 1) result.push("gap-" + value);
    result.push(value);
  });
  return result;
}
